/* eslint-disable */
import { create } from 'zustand';
import { subscribeWithSelector } from 'zustand/middleware';
import {
	initialStatsSummary,
	initialTabs,
	initialAnalysisTabs,
	initialQCTypes,
	initialConfigTypes,
	initialTimeRangesDropdown,
	initialFailureParameters,
	assetWiseDropdown,
	geographyWiseDropdown,
	initialAnalysisData,
	initialStatisticalAnalysisData,
	machineParameters,
} from './tempData';

export const useAnalysisStore = create(
	subscribeWithSelector((set, get) => ({
		loading: false,
		setLoading: (loading) => set({ loading }),

		// statsSummary: initialStatsSummary,
		// setStatsSummary: (statsSummary) => set({ statsSummary }),
		tabs: initialTabs,
		activeTab: initialTabs.find((t) => t.active)?.key || initialTabs?.[0]?.key,
		// setTabs: (tabs) => set({
		// 	tabs,
		// 	activeTab: tabs.find(t => t.active)?.key || tabs[0].key,
		// }),
		setActiveTab: (key) =>
			set((state) => ({
				tabs: state.tabs.map((tab) => ({
					...tab,
					active: tab.key === key,
				})),
				activeTab: key,
				cardData: [],
				statisticalAnalysisData: initialStatisticalAnalysisData,
			})),

		analysisTabs: initialAnalysisTabs,
		activeAnalysisTab:
			initialAnalysisTabs.find((t) => t.active)?.key ||
			initialAnalysisTabs?.[0]?.key,
		// setAnalysisTabs: (analysisTabs) => set({
		// 	analysisTabs,
		// 	activeAnalysisTab: analysisTabs.find(t => t.active)?.key || analysisTabs[0].key,
		// }),
		setActiveAnalysisTab: (key) =>
			set((state) => ({
				analysisTabs: state.analysisTabs.map((tab) => ({
					...tab,
					active: tab.key === key,
				})),
				activeAnalysisTab: key,
				cardData: [],
				statisticalAnalysisData: initialStatisticalAnalysisData,
			})),

		// QC Types
		qcTypes: initialQCTypes,
		activeQCType:
			initialQCTypes.find((t) => t.active)?.key || initialQCTypes?.[0]?.key,
		setActiveQCType: (key) =>
			set((state) => ({
				qcTypes: state.qcTypes.map((t) => ({
					...t,
					active: t.key === key,
				})),
				activeQCType: key,
				cardData: [],
				statisticalAnalysisData: initialStatisticalAnalysisData,
			})),

		// Config Types
		configTypes: initialConfigTypes,
		activeConfigType:
			initialConfigTypes.find((t) => t.active)?.key ||
			initialConfigTypes?.[0]?.key,
		setActiveConfigType: (key) =>
			set((state) => ({
				configTypes: state.configTypes.map((t) => ({
					...t,
					active: t.key === key,
				})),
				activeConfigType: key,
				cardData: [],
				statisticalAnalysisData: initialStatisticalAnalysisData,
			})),

		chartSelectionObj: null,
		setChartSelectionObj: (obj) => set({ chartSelectionObj: obj }),

		// Time Ranges
		timeRangesDropdown: initialTimeRangesDropdown,
		activeTimeRangeDropdown:
			initialTimeRangesDropdown.find((t) => t.active)?.key ||
			initialTimeRangesDropdown?.[0]?.key,
		setActiveTimeRange: (key) =>
			set((state) => ({
				timeRangesDropdown: state.timeRangesDropdown.map((t) => ({
					...t,
					active: t.key === key,
				})),
				activeTimeRangeDropdown: key,
			})),
		
		globalProductList:[],
		setGlobalProductList: (globalProductList) => set({ globalProductList }),
		// Product Wise Dropdown
		assetWiseDropdown: assetWiseDropdown,
		activeAssetWiseDropdown:
			assetWiseDropdown.find((t) => t.active)?.key ||
			assetWiseDropdown?.[0]?.key,
		setActiveAssetWiseDropdown: (key) =>
			set((state) => ({
				assetWiseDropdown: state.assetWiseDropdown.map((t) => ({
					...t,
					active: t.key === key,
				})),
				activeAssetWiseDropdown: key,
			})),

		// Geography Wise Dropdown
		geographyWiseDropdown: geographyWiseDropdown,
		activeGeographyWiseDropdown:
			geographyWiseDropdown.find((t) => t.active)?.key ||
			geographyWiseDropdown?.[0]?.key,
		setActiveGeographyWiseDropdown: (key) =>
			set((state) => ({
				geographyWiseDropdown: state.geographyWiseDropdown.map((t) => ({
					...t,
					active: t.key === key,
				})),
				activeGeographyWiseDropdown: key,
			})),

		// Date Range - legacy format - will be deprecated
		dateRangeObj: {
			from: null, // Date object for from date
			to: null, // Date object for to date
			viewFormat: {
				// Formatted strings for display
				from: '',
				to: '',
			},
		},
		setDateRangeObj: (dateRangeObj) =>
			set((state) => ({
				dateRangeObj: { ...state.dateRangeObj, ...dateRangeObj },
			})),

		// Detailed date information for backend
		dateInfo: {
			year: new Date().getFullYear(),
			month: new Date().getMonth() + 1,
			day: new Date().getDate(),
			quarter: Math.floor((new Date().getMonth() + 3) / 3),
			week: null,
			period: 'year', // 'day', 'month', 'quarter', 'year'
		},
		setDateInfo: (dateInfo) =>
			set((state) => ({
				dateInfo: { ...state.dateInfo, ...dateInfo },
			})),
		searchQuery: '',
		setSearchQuery: (searchQuery) => set({ searchQuery }),

		// Failure Parameters
		assetAnalysisParameters: initialFailureParameters,
		setAnalysisParameters: (analysisParameters) =>
			set({ analysisParameters: [...machineParameters, ...analysisParameters] }),
		selectedAnalysisParameter: 'all',
		setSelectedAnalysisParameter: (selectedParam) =>
			set({ selectedAnalysisParameter: selectedParam ,selectedAnalysisParameterProduct:null ,searchQuery:'' , cardData: [], statisticalAnalysisData: initialStatisticalAnalysisData }),

		analysisChartData: initialAnalysisData,
		setAnalysisChartData: (analysisChartData) =>
			set({ analysisChartData }),

		analysisParameterProducts: [],
		setAnalysisParameterProducts: (analysisParameterProducts) =>
			set({ analysisParameterProducts }),
		selectedAnalysisParameterProduct: null,
		setSelectedAnalysisParameterProduct: (selectedAnalysisParameterProduct) =>
			set({ selectedAnalysisParameterProduct, cardData: [], statisticalAnalysisData: initialStatisticalAnalysisData }),

		cardData: [],
		triggerChartUpdateApiCall: false,

		setCardData: (newCardData, triggerUpdate = false) => {
			let prev = get().triggerChartUpdateApiCall;
			if (triggerUpdate) {
				set({
					cardData: newCardData,
					triggerChartUpdateApiCall: !prev,
				});
			}
			set({
				cardData: newCardData,
			});
		},

		statisticalLoading: false,
		setStatisticalLoading: (statisticalLoading) =>
			set({ statisticalLoading }),

		statisticalAnalysisData: initialStatisticalAnalysisData,
		setStatisticalAnalysisData: (statisticalAnalysisData) =>
			set({ statisticalAnalysisData }),

		collapsedCards: [],
		setCollapsedCards: (collapsedCards) => set({ collapsedCards }),

		timeFrame: 'Daily',
		setTimeFrame: (timeFrame) => {
			set({ timeFrame, cardData: [], statisticalAnalysisData: initialStatisticalAnalysisData });
		},
	}))
);
